export default "__VITE_ASSET__dkbu$_jH__"